export default __webpack_public_path__ + "static/media/sf1.f52a6ff0.jpeg";